export class LoadInvitations {
  static readonly type = '[Accountant Invitations] Load Invitations';
  constructor(public readonly organizationId: number) {}
}
